<template>
  <ClickArea
    v-on="$listeners"
    v-bind="$attrs"
    :item="navigationItem"
    class="navigation-item fill-white f-body b flex items-center"
    :class="{'-disable': navigationItem.disable, '-active': active}"
  >
    <UIIcon class="icon flex-shrink-0 mr4" v-if="navigationItem.icon" :name="navigationItem.icon" />
    <span class="flex-auto">{{ navigationItem.name }}</span>
    <span
      class="notification f-label"
      v-if="navigationItem.notification"
    >{{ navigationItem.notification }}</span>
    <UIIcon v-if="navigationItem.children" class="chevron ml-auto" name="chevron-right" />
  </ClickArea>
</template>

<script>
import UIIcon from '@sbvr/common/legacy-shared/components/ui/UIIcon';
import ClickArea from '@sbvr/component-helpers/ClickArea';

export default {
  name: 'NavigationItem',
  components: {
    UIIcon,
    ClickArea,
  },
  props: {
    navigationItem: {
      required: true,
      type: Object,
    },
    active: {
      type: Boolean,
    },
  },
};
</script>

<style lang="postcss" scoped>
.navigation-item {
  cursor: pointer;
  padding: var(--spacingSm);
  color: var(--colorLight);
  text-decoration: none;
  opacity: 0.5;
  transition: opacity 0.3s ease;
  will-change: opacity;
  &:hover,
  &.router-link-active,
  &.-active {
    opacity: 1;
  }
}
.icon {
  height: 2rem;
  width: 2rem;
}
.notification {
  margin: 0;
  border-radius: 50%;
  background: var(--colorSBRed);
  color: var(--colorLight);
  width: 2rem;
  height: 2rem;
  overflow: hidden;
  text-align: center;
  line-height: 2rem;
  opacity: 1;
}
</style>
